import { Component } from '@angular/core';
import { MyharrellsService } from '../myharrells.service';
import { stringify } from 'querystring';
import { Dotcom2024Service } from '../dotcom2024.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-myharrellspasswordreset',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './myharrellspasswordreset.component.html',
  styleUrl: './myharrellspasswordreset.component.css'
})
export class MyharrellspasswordresetComponent {
  password: string = "";
  passwordConfirm: string = "";
  userId: string = "";
  checkValue: string = "";
  displayLoginFailure: boolean = false;
  failureText: string = "";
  displaySuccessAlert: boolean = false;
  successText: string = "";


  constructor(public myHarrellsService: MyharrellsService, public dotComService: Dotcom2024Service, public router: Router) { }

  ngOnInit() {
    //get query string params from url

    const urlParams = new URLSearchParams(window.location.search);
    this.userId = urlParams.get('userId') || "";
    this.checkValue = urlParams.get('code') || "";

  }

  HideLoginFailure() {
    this.displayLoginFailure = false;
  }

  HideSuccessAlert() {
    this.displaySuccessAlert = false;
  }

  SubmitClicked() {
    //validate against table values created when user requested password reset email

    //passords must match and be at least 8 characters 
    if (this.password.trim() == "" || this.password != this.passwordConfirm || this.password.length < 8) {
      this.failureText = "Passwords must match and be at least 8 characters. Please confirm your passords and try again.";
      this.displayLoginFailure = true;
    }
    else {
      this.myHarrellsService.PerformPasswordReset(this.userId, this.checkValue, this.password, this.passwordConfirm).subscribe((data: any) => {

        if (data == "failed") {
          this.failureText = "Password reset failed. Please try again.";
          this.displayLoginFailure = true;
        }
        else {
          this.successText = "Password reset successful.  Please login with your new password.";
          this.displaySuccessAlert = true;
          this.password = "";
          this.passwordConfirm = "";
          this.router.navigate(['/myharrellslogin']);
        }
      })
    }
  }

  CancelResetClicked() {
    this.password = "";
    this.passwordConfirm = "";
    this.router.navigate(['/myharrellslogin']);
  }

}
